import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Grid } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";

import { getAssignmentData, getUserLogs, getAssignmentLearnersData, getTasksUuid } from "../Services";
import AssignmentReportCard from "./AssignmentReportCard";

import TopButton from "../../../Components/UI/TopButtons";
import Placeholder from "../../../Components/UI/Placeholder";
import Confirmation from "../../../Components/Modal/Confirmation";
import { getFormatedDate } from "../../../Js/TimeAndDate";

import { commonSliceActions } from "../../../Store/Slices/CommonSlice";


const AssignmentsList = () => {
    // Hooks
    const navigation = useNavigate();
    const classes = useStyles();
    const listInnerRef = useRef();
    const dispatch = useDispatch();

    const paginationVal = 11;

    //State
    const [assignmentData, setAssignmentData] = useState([]);
    const [alertFlag, setAlertFlag] = useState(false);
    const [filterData, setFilterData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [skipData, setSkipData] = useState(0);
    const [limitData, setLimitData] = useState(paginationVal);
    const [totalData, setTotalData] = useState(0);
    const [isFilter, setIsFilter] = useState(false);    
    const [filterParams, setFilterParams] = useState(null);

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);    
    const { loader } = useSelector((state) => state.common);

    // React logic hooks
    useEffect(() => {
        // resetAssignmentsState();  
        dispatch(commonSliceActions.resetState());
        dispatch(commonSliceActions.setLoader(true));
        fetchAssignmentReport();
        
    }, []);

    useEffect(() => {
        const paginationRender = async () => {
            dispatch(commonSliceActions.setLoader(true));
            await fetchAssignmentReport();
        }
        if (isFetching) {
            paginationRender();
        }
    }, [isFetching]);

    // Reset all states on successful login
    const resetAssignmentsState = () => {
        setAssignmentData([]);
        setAlertFlag(false);
        setFilterData([]);
        setIsFetching(false);
        setFilterParams(null);
    };

    // Fetch Assignment Report Data
    const fetchAssignmentReport = async () => {     
        let selectedTrainer;
        let learnerObj;
        if (userInfo.rolesInfo.title.toLowerCase() == 'trainer') {
            selectedTrainer = `'` + userInfo.uid + `'`;
        } else if (userInfo.rolesInfo.title.toLowerCase() == 'learner') {
            learnerObj = userInfo.uid;
        }
        let params;

        //If filter apply
        if (isFilter) {
            params = filterParams;
        } else {
            params = {
                "learners": learnerObj,
                "created_by": selectedTrainer,
                "site_uuid": userInfo.site_uuid,                
            };
        }
        params.skip = skipData;
        params.limit = limitData;
        params.totalData = totalData;

        // console.log("params==========>",params);
        let resAssignmentData = await getAssignmentData(params);
        // console.log("resAssignmentData=====>", resAssignmentData);
        setIsFetching(false);
        setIsLoading(false);
        dispatch(commonSliceActions.setLoader(false));

        if (skipData == 0) {
            setTotalData(resAssignmentData.response.total);
            setAssignmentData(resAssignmentData.response.data);
        } else {
            let newData = [...assignmentData, ...resAssignmentData.response.data];
            setAssignmentData(newData);
        }
    };

    // Set params into Redux
    const redirectTo = async (reportData) => {
        if (Number(reportData.attemptedlearners) == 0) {
            setAlertFlag(true);
        } else {
            if (userInfo.rolesInfo.title.toLowerCase() == 'learner') {
                let params = {
                    query: {
                        $select: ['id'],
                        verb: 'attemptAssignment',
                        target: reportData.uid,
                        actor: userInfo.uid
                    }
                };
                let res = await getUserLogs(params);

                if (res.data.data.length === 0) {
                    setAlertFlag(true);
                } else {
                    let params = {
                        uid: reportData.uid,
                        learners: [userInfo.uid],
                        site_uuid: reportData.site_uuid
                    };
                    let learnerData = null;
                    let resLearnersData = await getAssignmentLearnersData(params);
                    let totalAssetData = await fetchTaskData(reportData);

                    learnerData = resLearnersData.response[0];
                    learnerData.totalAssets = totalAssetData;
                    learnerData.uid = userInfo.uid;
                    learnerData.name = userInfo.name;
                    learnerData.belongs_to = userInfo.belongs_to;

                    //csv when download with status
                    if (Number(learnerData.attemptedassets) == 0) {
                        learnerData.status = 'Not Attempted';
                    } else if (Number(learnerData.attemptedassets) < Number(totalAssetData) && Number(learnerData.attemptedassets) > 0) {
                        learnerData.status = 'Pending';
                    } else if (Number(totalAssetData) == Number(learnerData.attemptedassets) || Number(totalAssetData) < Number(learnerData.attemptedassets)) {
                        learnerData.status = 'Completed';
                    }
                    learnerData.percentage = (learnerData.genericscore / learnerData.totalAssets * 100).toFixed(2);

                    dispatch(commonSliceActions.setParamsData({ "reportData": reportData, "selectedClasses": filterData, "learnerData": learnerData }));
                    navigation('/Report/LearnerAssetList');
                }

            } else if (userInfo.rolesInfo.title.toLowerCase() != 'learner') {
                // console.log("reportData======>", reportData);
                dispatch(commonSliceActions.setParamsData({ "reportData": reportData, "selectedClasses": filterData }));
                navigation('/Report/LearnerList')
            }
        }
    };

    const fetchTaskData = async (reportData) => {
        let params = {
            query: {
                $select: ['data1', 'tasktype'],
                uid: reportData.tasks.tasks,
                site_uuid: reportData.site_uuid
            }
        };
        let resTaskData = await getTasksUuid(params);

        let totalAssets = 0;
        resTaskData.data.forEach(element => {
            let assets;
            let tasktype = element.tasktype;
            if (tasktype == 'assets' || tasktype == 'library') {
                assets = element.data1.exersices;
            } else {
                assets = element.data1.media;
            }
            totalAssets = totalAssets + assets.length;
        });
        return totalAssets;
    };

    const handleFilterData = async (params) => {
        setSkipData(0);
        setLimitData(paginationVal);
        setIsFilter(true);
        setTotalData(0);
        dispatch(commonSliceActions.setLoader(true));
        // console.log("userInfo.rolesInfo.title=====>",userInfo.rolesInfo.title);
        if(userInfo.rolesInfo.title.toLowerCase() == 'incharge' || 
        userInfo.rolesInfo.title.toLowerCase() == 'admin' || 
        userInfo.rolesInfo.title.toLowerCase() == 'staff') {
            let selectedTrainer;
            if (params.selectedTrainers.length == 0) {
                params.created_by = selectedTrainer;
            } else {
                params.created_by = `'` + params.selectedTrainers.join("','") + `'`;
            }
        } else if (userInfo.rolesInfo.title.toLowerCase() == 'trainer') {
            // console.log("userInfo.uid=====>",userInfo.uid);
            params.created_by = `'` + userInfo.uid + `'`;
        }
        else if (userInfo.rolesInfo.title.toLowerCase() == 'learner') {
            params.learners = userInfo.uid;
        }

        params.site_uuid = userInfo.site_uuid;
        params.skip = 0;
        params.limit = paginationVal;
        params.totalData = 0;

        // console.log("params===>",params);
        if (params.start_date && params.end_date) {
            //params.createdDate = { 'commences': params.start_date, "expiries": params.end_date };
            params.createdDate = { 'commences': getFormatedDate(params.start_date,'YYYY-MM-DD'), "expiries": getFormatedDate(params.end_date,'YYYY-MM-DD') };
        }
        if (params.selectedClasses.length > 0) {
            setFilterData(params.selectedClasses);
        }
        setFilterParams(params);        
        let resAssignmentData = await getAssignmentData(params);
        setTotalData(resAssignmentData.response.total);
        setAssignmentData(resAssignmentData.response.data);
        dispatch(commonSliceActions.setLoader(false));
    };
    const handleInfinityScroll = () => {
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            let totalHeight = Math.ceil(scrollTop + clientHeight);
            if (totalHeight >= scrollHeight || totalHeight == scrollHeight - 1 || totalHeight === scrollHeight) {
                return true;
            }
            return false;
        }
    };
    const handleLoadMore = () => {        
        if(assignmentData && +assignmentData.length < +totalData){
            setIsLoading(true);
        }
        setTimeout(() => {
            if ((skipData / paginationVal) < (Math.ceil(totalData / paginationVal) - 1)) {
                let totSkipData = skipData + limitData;
                console.log("totSkipData", totSkipData);
                setSkipData(() => totSkipData);
                setLimitData(() => limitData);
                setIsFetching(() => true);
            }
        }, 1000);
    };
    return (
        <>
            <TopButton
                title={`Assignment Reports`}
                secondaryText= {assignmentData.length > 0 ? `${assignmentData.length}/${totalData}` : ``}                
                centerText={isLoading ? "Loading..." : ""}
                isReportFilter={true}
                handleFilter={handleFilterData}
            />

            <Box
                onScroll={() => {
                    if (handleInfinityScroll()) {
                        handleLoadMore();
                    }
                }}
                ref={listInnerRef}
                sx={{ height: '80vh', overflow: isLoading ? 'hidden': 'auto', justifyContent: 'flex-start', mx: 3, width: '100%', '@media (min-width: 1636px)': { mx: 7 } }}
                 
            >
                {assignmentData.length > 0 && (
                    <Grid
                        container
                        gap={4}
                    >       {
                            assignmentData.map((reportData, index) => {
                                return (
                                    <Grid item key={`assignment_${index}`}>
                                        <AssignmentReportCard
                                            reportData={reportData}
                                            roleData={userInfo.rolesInfo}
                                            press={() => { redirectTo(reportData) }}
                                        />
                                    </Grid>
                                );
                            })
                        }
                    </Grid>
                )}
                {!loader && assignmentData.length === 0 &&  (
                    <Placeholder
                        primaryText="No assignment found"
                        secondaryText="No data found!"
                        image="assign"
                    ></Placeholder>
                )}
            </Box>
            <Confirmation
                image="error"
                primaryText="Not attempted!!"
                visible={alertFlag}
                toggleModal={(flag) => setAlertFlag(flag)}
                alert={true}
                timeout={2200}
            />
        </>
    );
};
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
});
export default AssignmentsList;
